import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card, NavLink, Badge} from 'react-bootstrap';
import { LAYOUT } from 'constants.js';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import Clamp from 'components/clamp';
import {format} from 'date-fns';
import _ from 'lodash';
import PropTypes from 'prop-types';

const ProjectCard = ({user, project, ...props}) => {
  
  return (
    <Card className="mb-5">
      <Card.Body>
        <Row className="g-0">
          <Col xs="auto" className="me-3">
          <div className="bg-foreground sw-8 sh-8 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center" style={{marginTop:"-6px"}}>
            {(project.icon && project.icon!=="")?<img className="card-img rounded-xl sh-6 sw-6" src={project.icon} alt="Project Icon" />:<div className="bg-gradient-light sw-6 sh-6 rounded-xl">
              <div className="text-white d-flex justify-content-center align-items-center h-100 text-small text-center lh-1">
                <CsLineIcons icon="flash" size="24"/>
              </div>
            </div>}
          </div>
          </Col>
          <Col>
            <div className="mt-2 mb-0 font-size-1rem font-weight-bold">
              {project.title}
              {(project.liveLink && project.liveLink!=="")?<a href={project.liveLink} target="_blank" variant="foreground" size="sm" title="Project Url" className="btn-icon btn-icon-only hover-outline ms-1" rel="noreferrer"><CsLineIcons icon="link" /></a>:''}
              {(project.repoLink && project.repoLink!=="")?<a href={project.repoLink} target="_blank" variant="foreground" size="sm" title="Repo Url" className="btn-icon btn-icon-only hover-outline ms-1" rel="noreferrer"><CsLineIcons icon="code" /></a>:''}
            </div>
            <p className="text-muted">Project-Id : {project.id.toUpperCase().substring(3)}{(project.subTitle && project.subTitle!=="")?` | ${project.subTitle}`:''}</p>
          </Col>
        </Row>
        <Card.Text className="mt-4 mb-4 ms-1">
          <ul>
            <li>
              <p className="text-primary mb-0">What was the project all about?</p>
              <p>{project.projectDescription}</p>
            </li>
            <li>
              <p className="text-primary mb-0">What were your role & responsibilities?</p>
              <p>{project.roleTitle}</p>
              <p>{project.roleDescription}</p>
            </li>
            {project.description && !_.isEmpty(project.description) && project.description.map((desc) =>  
            <li key={desc.questionId}>
              <p className="text-primary mb-0">{desc.question}</p>
              <p dangerouslySetInnerHTML={{ __html: desc.questionResponse }} />
            </li>
             )
            }
            {/*
            <li>
              <p className="text-primary mb-0">
                <Row className="align-items-center">
                  <Col className="align-items-center">Team</Col>
                  <Col>
                    <div className="d-flex flex-nowrap justify-content-end align-items-center text-body text-medium">
                      <div className="me-1 mb-1">Core Team (3)<span className="text-separator ps-1 pe-1">|</span>Consultants (1) <span className="text-separator ps-1 pe-1">|</span></div>
                      <div><Button href="#colors" variant="link" className="mb-1 ms-0 me-0 ps-0 pe-0">Hide Individual Details</Button></div>
                    </div>  
                  </Col>
                </Row>
              </p>
              <Row className="row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-2">
                <Col>
                  <Card className="h-100">
                    <Card.Body className="text-center">
                      <div className="sw-13 position-relative mb-3 mx-auto">
                        <img src="/img/profile/profile-1.png" className="img-fluid rounded-xl" alt="thumb" />
                      </div>
                      <NavLink to="/instructor/detail" className="mb-3 stretched-link body-link">Sagar Srivastava</NavLink>
                      <div className="text-muted text-medium mb-2">Team Lead</div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card className="h-100">
                    <Card.Body className="text-center">
                      <div className="sw-13 position-relative mb-3 mx-auto">
                        <img src="/img/profile/profile-13.jpeg" className="img-fluid rounded-xl" alt="thumb" />
                      </div>
                      <NavLink to="/instructor/detail" className="mb-3 stretched-link body-link">Pooja Sharma</NavLink>
                      <div className="text-muted text-medium mb-2">Full-Stack Developer</div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card className="h-100">
                    <Card.Body className="text-center">
                      <div className="sw-13 position-relative mb-3 mx-auto">
                        <img src="/img/profile/profile-12.jpeg" className="img-fluid rounded-xl" alt="thumb" />
                      </div>
                      <NavLink to="/instructor/detail" className="mb-3 stretched-link body-link">Kunal Jaiswal</NavLink>
                      <div className="text-muted text-medium mb-2">Frontend Developer</div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card className="h-100">
                    <Badge pill bg="warning" className="me-1 position-absolute s-n2 t-2 z-index-1 t-1">Consultant</Badge>
                    <Card.Body className="text-center">
                      <div className="sw-13 position-relative mb-3 mx-auto">
                        <img src="/img/profile/profile-14.jpeg" className="img-fluid rounded-xl" alt="thumb" />
                      </div>
                      <NavLink to="/instructor/detail" className="mb-3 stretched-link body-link">Shreya Singh</NavLink>
                      <div className="text-muted text-medium mb-2">UI Designer</div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card className="no-shadow mt-2 mb-2 p-3">
                    <div>
                      <div className="text-primary">Pooja Sharma</div>
                      <div className="text-medium text-muted">Product Management, Fullstack Development</div>
                    </div>
                    <div className="text-medium">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
                    labore wes anderson cred nesciunt sapiente ea proident.
                    </div>
                  </Card>
                  <Card className="mt-2 mb-2 p-3 project-role-self">
                    <div>
                      <div className="text-primary">Sagar Srivastava</div>
                      <div className="text-medium text-muted">Team Lead, Product Management, Program Management, Content Editing</div>
                    </div>
                    <div className="text-medium">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
                    labore wes anderson cred nesciunt sapiente ea proident.
                    </div>
                  </Card>
                  <Card className="no-shadow mt-2 mb-2 p-3">
                    <div>
                      <div className="text-primary">Kunal Jaiswal</div>
                      <div className="text-medium text-muted">Frontend Development, Devops</div>
                    </div>
                    <div className="text-medium">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer
                    labore wes anderson cred nesciunt sapiente ea proident.
                    </div>
                  </Card>
                  <Card className="no-shadow mt-2 mb-2 p-3">
                    <div>
                      <div className="text-primary">Shreya Singh</div>
                      <div className="text-medium text-muted">Consultant UI Designer</div>
                    </div>
                    <div className="text-medium">Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.
                    </div>
                  </Card>
                </Col>
              </Row>
            </li>
            */}
          </ul>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default ProjectCard;
ProjectCard.propTypes = {
  user: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired
}